declare namespace $ {

	export class $mol_icon_drag extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=drag.view.tree.d.ts.map